import { type Objectish, type Patch, enablePatches, produce } from "immer";
import { Subject, startWith } from "rxjs";

import type { CanvasSpecifier } from "@moment/api-collab/api-types";
import { type DoTransactionFn } from "@moment/api-collab/metadata-state";
import { observableToAsyncGenerator } from "@moment/api-collab/observableToAsyncGenerator";
import type { PageStorageBridge } from "@moment/api-collab/page-local-storage/client";

// Required in v6.
enablePatches();

/**
 * An UNSAFE, NO-OP, NON-PRODUCTION-QUALITY implementation of the
 * `PageStorageBridge` interface, used primarily for testing and development.
 *
 * THIS BRIDGE IS A BRIDGE TO NOWHERE.
 */
export class UnsafeNoOpPageStorageBridge implements PageStorageBridge {
	private _data: Objectish = {};
	private _dataUpdates = new Subject<Objectish>();

	constructor(public readonly pageInfo: CanvasSpecifier) {}

	storageFor = async (_canvasId: string, _pageID: string): Promise<PageStorageBridge> => {
		return this;
	};

	get data(): AsyncIterableIterator<Objectish> {
		return observableToAsyncGenerator(this._dataUpdates.pipe(startWith(this._data)));
	}

	commit = async (doTransaction: DoTransactionFn<Objectish>): Promise<void> => {
		const patches: Patch[] = [];
		const inversePatches: Patch[] = [];
		const newData = produce<Objectish>(
			this._data,
			doTransaction,
			(_patches, _inversePatches) => {
				patches.push(..._patches);
				inversePatches.push(..._inversePatches);
			}
		);

		this._data = newData;
		this._dataUpdates.next(this._data);
	};

	dispose() {
		this._dataUpdates.complete();
	}
}
